import styled from 'styled-components'

const BodyBenefits = styled.div`
  padding: 24px;
  @media (min-width: 992px) {
    padding: 45px 120px;
  }
  > a {
    @media (min-width: 992px) {
      min-width: 210px;
      width: fit-content;
      max-width: 244px;
      margin: 0 auto;
    }
  }
`

const ButtonBenefits = styled.a`
  display: flex;
  padding: 11px 32px;
  background: #00518E;
  border-radius: 8px;
  margin-bottom: 16px;
  color: #fff;
  font-family: 'Noto Sans', sans-serif;
  font-weight: 700;
  justify-content: center;
  @media (min-width: 992px) {
    min-width: 210px;
    width: fit-content;
    max-width: 244px;
    margin: 0 auto;
  }

  &:hover {
    background: #1B2A68;
  }
`

const ButtonJoinTag = styled.a`
  display: flex;
  padding: 11px 32px;
  background: #222F64;
  border-radius: 8px;
  margin: -40px auto 40px;
  color: #fff;
  font-family: 'Noto Sans', sans-serif;
  font-weight: 700;
  justify-content: center;
  cursor: pointer;
  @media (min-width: 992px) {
    min-width: 210px;
    width: fit-content;
    max-width: 244px;
    margin: -40px auto 40px;
  }
`

const WrapperHeader = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  max-width: 1200px;
  margin: auto;
  padding-top: 0px;

  @media (min-width: 992px) {
    margin-left: max(120px, calc((100% - 1200px) / 2));
    margin-right: max(120px, calc((100% - 1200px) / 2));
    padding-top: 40px;
  }
`

const Wrapper = styled.div`
  @media (min-width: 992px) {
    display: flex;
    flex-direction: column;
    max-width: 1200px;
    margin: auto;
  }
`

const HomeFlag = styled.div`
  position: absolute;
  top: -1px;
  right: 24px;
  height: 64px;

  svg {
    height: 100%;
    width: auto;
  }

  @media (min-width: 992px) {
    height: 120px;
    right: 0px;
  }
`


export { BodyBenefits, ButtonBenefits, Wrapper, WrapperHeader, ButtonJoinTag, HomeFlag }
